import * as ko from "knockout";
import AbstractInput from "./AbstractInput";
import {global} from "../../appContext";
import {nsFa} from "../fa/fn";
import {IDynamicVariableTextInputParams} from "./index";
import i = nsFa.i;
import text_inputHtml from './text-input.html?raw';

export let template = text_inputHtml;

export class viewModel extends AbstractInput {
    private canOpenInDialog: boolean;

    constructor(protected override params: IDynamicVariableTextInputParams) {
        super(params);
        this.canOpenInDialog = params.canOpenInDialog ?? true;
    }

    protected override onViewReady() {
        super.onViewReady();
        this.shadow.style.whiteSpace = 'pre';
    }

    private onEditExpressionClick() {
        global.dialogManager.addComponent({
            title: `${i('fa-pencil-ruler')} ((edit expression))`,
            content: {
                name: 'component/dynamic-variable/dialog/builder',
                params: {
                    expression: this.expression,
                    objectTypeId: ko.unwrap(this.params.objectTypeId),
                    objectTypeIds: ko.unwrap(this.params.objectTypeIds),
                },
            }
        });
    }

    protected override updateShadowStyle() {
        super.updateShadowStyle()
        this.shadow.style.whiteSpace = "nowrap";
    }

}
